import SiteNav from "./SiteNav";
import infoCss from "../styles/info.css?raw";
import Brand from "./Brand";
import SbrFooter from "./SbrFooter";
import SlCloudFooter from "../brands/servicelad/SlCloudFooter";
import { SERVICE_HISTORY_PATH, hasServiceHistoryPages } from "../content/serviceHistoryRoutes";

export function InfoHeader({ brand }) {
  return <SiteNav brand={brand} />;
}

export function InfoFooter({ brand }) {
  if (brand.key === "servicebyreg") {
    return <SbrFooter brand={brand} />;
  }
  if (brand.key === "servicelad") {
    return <SlCloudFooter brand={brand} />;
  }

  return (
    <footer>
      <div className="wrap">
        <div className="footer-top">
          <Brand brand={brand} light />
          <div className="footer-links">
            {hasServiceHistoryPages(brand.key) && <a href={SERVICE_HISTORY_PATH}>Service history check</a>}
            <a href="/v5c-alerts">V5C alerts</a>
            <a href="/car-tax-calculator/">Tax calculator</a>
            <a href="/insurance-groups">Insurance group</a>
            <a href="/free-car-check">Free car check</a>
            {brand.key === "servicebyreg" && <a href="/vehicle-check">Tax and MOT check</a>}
            {brand.guides?.length > 0 && <a href="/guides/">Guides</a>}
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 {brand.name}. All rights reserved.</span>
          <span>Vehicle details come from trusted sources. {brand.name} is not part of DVLA or DVSA.</span>
        </div>
      </div>
    </footer>
  );
}

export default function InfoLayout({ brand, eyebrow, title, intro, children }) {
  const body = (
    <>
      <style>{infoCss}</style>
      <InfoHeader brand={brand} />
      <main className={brand.key === "servicelad" ? "relative z-10" : undefined}>
        {title && (
          <section className="hero">
            <div className="wrap">
              <div className="eyebrow">{eyebrow}</div>
              <h1>{title}</h1>
              <p>{intro}</p>
            </div>
          </section>
        )}
        {children}
      </main>
      <InfoFooter brand={brand} />
    </>
  );

  if (brand.key === "servicelad") {
    return (
      <div className="sl-cloud relative min-h-screen bg-background text-foreground font-body">
        <div className="atmosphere" aria-hidden />
        {body}
      </div>
    );
  }

  return body;
}
